var render, staticRenderFns
import script from "./ClientOnly.vue?vue&type=script&lang=js&"
export * from "./ClientOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\PlentyMarkets\\30401\\39\\BiomentaVueTheme\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ae213ce')) {
      api.createRecord('7ae213ce', component.options)
    } else {
      api.reload('7ae213ce', component.options)
    }
    
  }
}
component.options.__file = "resources/js/src/app/components/common/ClientOnly.vue"
export default component.exports